/* -------------------------------------------------------------------------
 * Sayuri signature · citrus-mist  (Kōchi no Yume)
 * -------------------------------------------------------------------------
 * Port of `CitrusMist` in the design file (line ~998). Tiny accent-tinted
 * sparks bursting upward with a soft glow — like dust motes catching
 * morning light over a yuzu grove. No spin, no sway, pure rise-and-fade.
 *
 * Scent character: "Yuzu picked at dawn, river mist, wet stone."
 * ----------------------------------------------------------------------- */
(function () {
  'use strict';
  var SA = window.SayuriAnimations;
  if (!SA) { return; }

  SA.register('citrus-mist', {
    mount: function (el, ctx) {
      // Density + duration tuned to match the calmness pace of Tea Garden's
      // tea-leaves-drift (28–46s) and Momiji's maple-fall (16–30s). The
      // earlier 4–10s with n=50–80 read as frenetic — yuzu groves at dawn
      // should feel like dust motes catching light, not a fountain.
      var n = ctx.intensity === 'lush' ? 36 : 24;
      var accent = ctx.accent;
      var rand = ctx.seed('citrus-mist'.charCodeAt(0) * 131 + 11 * 7919);

      var frag = document.createDocumentFragment();
      for (var i = 0; i < n; i++) {
        var left = rand() * 100;
        var top = 40 + rand() * 60;       // seeded from lower half
        var size = 2 + rand() * 4;        // 2–6px (tiny)
        var dur = 14 + rand() * 12;       // 14–26s (was 4–10s; way too fast)
        var delay = -rand() * 22;          // longer phase spread for sparseness
        var variant = i % 3;

        var p = document.createElement('div');
        p.className = 'sayuri-citrus-spark';
        p.style.position = 'absolute';
        p.style.left = left + 'vw';
        p.style.top = top + 'vh';
        p.style.width = size + 'px';
        p.style.height = size + 'px';
        p.style.borderRadius = '50%';
        p.style.background = 'radial-gradient(circle, ' + accent + ', ' + accent + '00 70%)';
        p.style.boxShadow = '0 0 ' + (size * 3) + 'px ' + accent + '88';
        p.style.opacity = '0';
        p.style.animation = 'cit-rise-' + variant + ' ' + dur + 's ease-in ' + delay + 's infinite';

        frag.appendChild(p);
      }
      el.appendChild(frag);
    },
    css: [
      '@keyframes cit-rise-0 { 0%{opacity:0;transform:translate(0,0) scale(0.3);} 30%{opacity:1;} 100%{opacity:0;transform:translate(20px,-200px) scale(1.3);} }',
      '@keyframes cit-rise-1 { 0%{opacity:0;transform:translate(0,0) scale(0.3);} 30%{opacity:1;} 100%{opacity:0;transform:translate(-30px,-180px) scale(1.4);} }',
      '@keyframes cit-rise-2 { 0%{opacity:0;transform:translate(0,0) scale(0.3);} 30%{opacity:1;} 100%{opacity:0;transform:translate(10px,-220px) scale(1.2);} }'
    ].join('')
  });
})();
